module.exports = __webpack_public_path__ + "img/35-4.2a45e940.jpg";